import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "./api"; // ✅ shared axios client

function EditWorkOrder() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    date: "",
    line: "",
    machine: "",
    task: "",
    lead_time: "",
    assignee: "",
    scheduled_date: "",
    status: "open",
    type: "",
  });

  useEffect(() => {
    setLoading(true);
    api
      .get("/api/work-orders")
      .then((res) => {
        const found = (res.data || []).find((wo) => String(wo.id) === String(id));
        if (found) setFormData({ ...formData, ...found });
      })
      .catch((err) => console.error("Error fetching work order", err))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/api/work-orders/${id}`, formData);
      alert("✅ Work Order updated!");
      navigate("/work-orders");
    } catch (err) {
      console.error("Error updating", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err.message ||
        "Unknown error";
      alert(`❌ Failed to update work order: ${msg}`);
    }
  };

  const types = ["Preventive", "Corrective", "Predictive", "Project"];

  if (loading) {
    return (
      <div className="main-content">
        <h1>✏️ Edit Work Order #{id}</h1>
        <p style={{ color: "#9ca3af" }}>Loading...</p>
      </div>
    );
  }

  return (
    <div className="main-content">
      <h1>✏️ Edit Work Order #{id}</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Created Date:</label>
          <input
            type="date"
            name="date"
            value={formData.date || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Line:</label>
          <input
            type="text"
            name="line"
            value={formData.line || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Machine:</label>
          <input
            type="text"
            name="machine"
            value={formData.machine || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Task:</label>
          <textarea
            name="task"
            value={formData.task || ""}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <div>
          <label>Work Order Type:</label>
          <select
            name="type"
            value={formData.type || ""}
            onChange={handleChange}
            required
          >
            <option value="">Select Type</option>
            {types.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Lead Time:</label>
          <input
            type="date"
            name="lead_time"
            value={formData.lead_time || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Assignee:</label>
          <input
            type="text"
            name="assignee"
            value={formData.assignee || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Scheduled Date:</label>
          <input
            type="date"
            name="scheduled_date"
            value={formData.scheduled_date || ""}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Status:</label>
          <select
            name="status"
            value={formData.status || "open"}
            onChange={handleChange}
            required
          >
            <option value="open">Open</option>
            <option value="completed">Completed</option>
            <option value="not completed">Not Completed</option>
            <option value="reopened">Reopened</option>
            <option value="closed">Closed</option>
            <option value="project">Project</option>
          </select>
        </div>

        <br />
        <button type="submit">Save Changes</button>
      </form>
    </div>
  );
}

export default EditWorkOrder;
